class BaseHelper {
    static getById (list, id) {
        const result = list.filter((item) => item.id === id);
        if (result.length > 0) {
            return result[0];
        }
    }
}

export default BaseHelper;
